function escapeCsvValue(value) {
  let stringValue = value == null ? "" : String(value);
  // Spreadsheet programs may execute cells beginning with these characters.
  if (/^[\s]*[=+\-@]/.test(stringValue)) stringValue = `'${stringValue}`;
  if (/[",\n]/.test(stringValue)) return `"${stringValue.replace(/"/g, '""')}"`;
  return stringValue;
}

export function downloadCsv(filename, columns, rows) {
  const header = columns.map((column) => escapeCsvValue(column.label)).join(",");
  const lines = rows.map((row) => columns.map((column) => escapeCsvValue(column.value(row))).join(","));
  const csv = [header, ...lines].join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}
